<template>
  <div id="app">
    <TopBanner class="banner"></TopBanner>
    <div class="icons">
      <SectionIcon v-for="(icon, index) in icons" :key="index" :iconName="icon" :is-active="isActive(index)" @clicked="switchTo(index)" @next-section="nextSection"></SectionIcon>
    </div>
    <div :class="['section', direction]">
      <SectionContent class="section-content" :current-section="currentSection"></SectionContent>
    </div>
    <div class="contact">
      <a href="mailto:info@nnumerics.com">info@nnumerics.com</a>
    </div>
  </div>
</template>



<script>
import TopBanner from './components/TopBanner.vue'
import SectionIcon from './components/SectionIcon.vue'
import SectionContent from './components/SectionContent.vue'

export default {
  name: 'app',
  components: {
    TopBanner,
    SectionIcon,
    SectionContent,
  },
  data() {
    return {
      currentSection: 0,
      direction: 'forward',
      icons: ['jam-cogs', 'jam-wrench', 'jam-screen', 'cloud', 'jam-rocket', 'books'],
    }
  },
  methods: {
    async switchTo(index) {
      const nextIndex = index >= this.icons.length ? 0 : index
      this.direction = nextIndex < this.currentSection ? 'back' : 'forward'
      await this.$nextTick()
      this.currentSection = nextIndex
    },
    nextSection() {
      this.switchTo(this.currentSection + 1)
    },
    isActive(index) {
      return this.currentSection === index
    },
  },
}
</script>



<style>

html, body, div, span,   
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym,  big, cite, code,
em, img, ins,  q, s, 
small, strike, strong, sub, sup, tt, var,
dl, dt, dd, ol, ul, li,
form, label, legend,
caption, canvas, embed, 
figure, figcaption, footer, header,
menu, nav {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
html {
  height: 100%;
}
body {
  line-height: 1;
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.banner {
  flex: 0 0 180px;
}
.icons {
  display: flex;
  flex: 0 0 80px;
}
.icons:before, .icons:after {
  content: "";
  /*background: red;*/
  flex: 4 0 0;
}
.section {
  display: flex;
  flex: 1 0 auto;
}
.section:before, .section:after {
  content: "";
  /*background: red;*/
  flex: 3 0 0;
}
.section-content {
  flex: 2 1 320px;
}
.contact {
  flex: 1 0 50px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.contact a {
  text-decoration: none;
  color: #2c3e50;
  margin-bottom: 20px;
}
.contact a:hover {
  color: #3CA0C8;
}
</style>
